
type Props = {
    text: string;
    imgSrc?: string;
    show: boolean;
    wrapperSpacingClass?: string;
}

const GenericErrorMsgComponent: React.FC<Props> = ({ show, text, imgSrc, wrapperSpacingClass = 'mb-3 mx-3' }) => {

    const noSearchResultsImg = "/Images/Components/EmptySearch.png";

    if (!show) return null;

    return (
        <div className={`text-center mst-generic-error mst-error-msg ${wrapperSpacingClass}`}>
            <div className="mx-auto mst-error-msg-title rubik-bold">{text}</div>
            <div className="mst-error-msg-img mx-auto">
                <img className="" src={imgSrc || noSearchResultsImg} alt="" />
            </div>
        </div>
    )
}

export default GenericErrorMsgComponent;